const getConfig = (item: string) => (window as any).envConfig[item]

export default getConfig
